const FontsAlignFoundationsZiniaThemes = {
    left: 'left',
    center: 'center',
    right: 'right',
};
export { FontsAlignFoundationsZiniaThemes };
//# sourceMappingURL=fonts-align-foundations.zinia.themes.js.map